import React, { useEffect, useState } from "react";
import { Box, TextField, Collapse, Typography, Button, IconButton } from "@mui/material";
import styles from '../my-data.module.scss';
import { observer } from "mobx-react";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getNameFromProfile } from "../../utils/profile-utils";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import LocationPicker from "./location-picker";
import AvailabilityModal from "./availability-modal";
import { Edit2 } from "iconsax-react";
import DeleteSectionModal from "./delete-section-modal";
import DeleteLabelModal from "./delete-label-modal";

const filter = createFilterOptions();

const InfoForm = observer(({
    editMode,
    label,
    info,
    update_info,
    showAdvanced,
    loading: parentLoading,
    language,
    uiStore,
    sectionErrors,
    section,
    updateData,
    category
}) => {
    const [options, setOptions] = useState([]);
    const [date, setDate] = useState(dayjs(info?.infoValue));
    const [value, setValue] = useState(label.multipleValues ? info?.infoValues : info?.infoValue);
    const [countryCode, setCountryCode] = useState('');
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [country, setCountry] = useState(null);
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [loading, setLoading] = useState(parentLoading);
    const [showAvailablityModal, setShowAvailablityModal] = useState(false);
    const [availability, setAvailability] = useState(null);
    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
    const [errors, setErrors] = useState(null);
    const [activeElem, setActiveElem] = useState(null);

    const handleAddressChange = async (e, value) => {
        const { id } = e.target;
        let updatedCountry = country;
        let updatedState = state;
        let updatedCity = city;

        if (id?.startsWith('country')) {
            updatedCountry = value;
            updatedState = null;
            updatedCity = null;
            setCountry(value);
            setState(null);
            setCity(null);
            const data = await uiStore.fetchInfoSuggestions('state', value.value);
            setStates(data.map(i => ({ value: i.id, label: i.name })));

        } else if (id?.startsWith('state')) {
            updatedState = value;
            updatedCity = null;
            setState(value);
            setCity(null);
            const data = await uiStore.fetchInfoSuggestions('city', country.value, value.label);
            setCities(data.map(i => ({ value: i.id, label: i.name })));

        } else {
            updatedCity = value;
            setCity(value);
        }

        update_info({
            infoLanguage: language?.language,
            label: label._id,
            category: label.category,
            section: label.section,
            infoType: label.infoType,
            multipleValues: label.multipleValues,
            id: info?._id,
            infoValues: [],
            infoValue: `${updatedCountry?.label}  ${updatedState?.value} ${updatedCity?.label}`,
            multiLang: label.multiLang,
            country: updatedCountry?.value,
            state: updatedState?.label,
            city: updatedCity?.label
        });

        //validateField(e);

    }

    const handleAutocompleteChange = (e, value) => {
        let multiple = Array.isArray(value);

        let newValue = value;
        if (multiple)
            newValue = newValue.map(i => typeof i === "string" ? i : i.inputValue)

        update_info({
            infoLanguage: language?.language,
            label: label._id,
            category: label.category,
            section: label.section,
            infoType: label.infoType,
            multipleValues: label.multipleValues,
            id: info?._id,
            infoValues: multiple ? newValue : [],
            infoValue: multiple ? '' : value?.value ? value?.value : value,
            multiLang: label.multiLang
        });

        setValue(newValue);

        //validateField(e);
    };

    const handleCountryCodeChange = (e, code) => {
        setCountryCode(code);

        update_info({
            infoLanguage: language?.language,
            label: label._id,
            category: label.category,
            section: label.section,
            infoType: label.infoType,
            multipleValues: label.multipleValues,
            id: info?._id,
            infoValue: value,
            countryCode: code?.value,
            multiLang: label.multiLang
        });

        //validateField(e);
    };

    const handleInfoChange = (e) => {
        const { value } = e.target;
        setValue(value);

        update_info({
            infoLanguage: language?.language,
            label: label._id,
            category: label.category,
            section: label.section,
            infoType: label.infoType,
            multipleValues: label.multipleValues,
            id: info?._id,
            infoValue: value,
            countryCode: countryCode?.value,
            multiLang: label.multiLang
        });
        //validateField(e);
    };

    const handleInfoDateChange = (value) => {

        if (dayjs(value).isValid()) {
            setDate(dayjs(value));
            update_info({
                infoLanguage: language?.language,
                label: label._id,
                category: label.category,
                section: label.section,
                infoType: label.infoType,
                multipleValues: label.multipleValues,
                id: info?._id,
                infoValue: dayjs(value),
                multiLang: label.multiLang
            });
        }
    }

    useEffect(() => {
        setValue(label.multipleValues ? info?.infoValues : info?.infoValue)

        async function fetchOptions() {
            setLoading(true);
            const data = await uiStore.fetchInfoSuggestions(label.infoType);
            setLoading(false);

            let suggestions = [];

            if (label.infoType === "number") {
                data.forEach((item, i) => {
                    if (!suggestions.find(e => e.value === (item.phone_code[0] === '+' ? item.phone_code : '+' + item.phone_code)))
                        suggestions.push({
                            value: (item.phone_code[0] === '+' ? item.phone_code : '+' + item.phone_code),
                            label: (item.phone_code[0] === '+' ? item.phone_code : '+' + item.phone_code),
                            icon: item.iso2
                        });
                });

                let selected = suggestions.find(element => element.value
                    === info?.countryCode);

                setCountryCode(selected);

            } else if (label.infoType === "address") {

                data.forEach((item, i) => {
                    suggestions.push({ value: item.name, label: item.name + " - " + item.native });
                });

                if (info) {

                    if (info.country) {
                        const selectedCountry = suggestions?.find(i => i.value === info.country);
                        setCountry(selectedCountry);
                        const stateOptions = await uiStore.fetchInfoSuggestions('state', info.country);
                        setStates(stateOptions.map(i => ({ value: i.id, label: i.name })));

                        if (info.state) {
                            const selectedState = stateOptions.find(i => i.name === info.state);
                            setState({ value: selectedState.id, label: selectedState.name });
                            const citiesOptions = await uiStore.fetchInfoSuggestions('city', info.country, info.state);
                            setCities(citiesOptions.map(i => ({ value: i.id, label: i.name })));

                            if (info.city) {
                                const selectedCity = citiesOptions.find(i => i.name === info.city);
                                setCity({ value: selectedCity.id, label: selectedCity.name });
                            }
                        }
                    }
                }

            } else if (label.infoType === "nsync-id") {
                data?.forEach((item, i) => {
                    suggestions.push({
                        value: item._id,
                        label: getNameFromProfile(item)
                    });
                });

            } else if (label.infoType === 'day-time') {
                if (info) {
                    const ava = await uiStore.getAvailability(info?.infoValue);
                    setAvailability(ava);
                }

            } else {
                suggestions = data;
                if (label?.multipleValues && value) {
                    value.forEach(i => { if (!suggestions.includes(i)) suggestions.push(i) });
                }
            }

            setOptions(suggestions);
        }

        if (label.infoType !== 'date' && label.infoType !== 'text')
            fetchOptions();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [info, label, editMode, language, uiStore]);


    useEffect(() => {

        if (availability)
            update_info({
                infoLanguage: language?.language,
                label: label._id,
                category: label.category,
                section: label.section,
                infoType: label.infoType,
                multipleValues: label.multipleValues,
                id: info?._id,
                infoValue: availability?._id,
                infoValues: [],
                multiLang: label.multiLang
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availability]);

    const filterOptions = (options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        const isExisting = options.some((option) => inputValue === option);
        if (inputValue !== '' && !isExisting) {
            filtered.push({
                inputValue,
                label: `Add "${inputValue}"`,
            });
        }

        return filtered;
    }

    const filterCountryCode = (options, params) => {
        let { inputValue } = params;
        if (inputValue[0] !== '+')
            inputValue = '+' + inputValue;

        const filtered = options.filter(i => i.value.startsWith(inputValue));
        return filtered;
    }

    const getOptionLabel = (option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
            return option;
        }

        // Add "xxx" option created dynamically
        if (option.inputValue) {
            return option.label;
        }

        // Regular option
        return option.label;
    };

    const handleLocationChange = (newLocation, zoom) => {
        update_info({
            infoLanguage: language?.language,
            label: label._id,
            category: label.category,
            section: label.section,
            infoType: label.infoType,
            multipleValues: label.multipleValues,
            id: info?._id,
            infoValue: JSON.stringify(newLocation),
            countryCode: countryCode?.value,
            multiLang: label.multiLang
        });
        //validateField(e);
    };

    // Disable autocomplete for the TextField
    const disableAutoComplete = (event) => {
        event.target.setAttribute('autocomplete', 'nope');
    };

    const manditory_fielsds = [
        'First Name',
        'Last Name',
        'Nickname',
        'Job Title',
        'Company',
        'Field',
        'Number',
        'E-mail Address',
        'Social Account',
        'Url',
        'About',
        'Location',
        'Country',
        'Birthday',
        'Anniversary',
        'Date',
        'Address',
    ];

    const validateField = (e) => {
        if (e.target && manditory_fielsds.includes(e.target.name)) {
            setActiveElem(e.target.id)
            if (!(e.target.value?.trim())) {
                setErrors('This field is required');
                if (!sectionErrors.current[section.name]) {
                    sectionErrors.current[section.name] = [];
                }

                if (!sectionErrors.current[section.name]?.includes(e.target.id)) {
                    sectionErrors.current[section.name].push(e.target.id);
                }
            } else {
                setErrors(null);
                if (!sectionErrors.current[section.name]) {
                    sectionErrors.current[section.name] = [];
                }

                if (sectionErrors.current[section.name]?.includes(e.target.id)) {
                    sectionErrors.current[section.name].shift(e.target.id);
                }
            }
        }
    };

    const handleChange = (event, value) => {
        setValue(value);
        //validateField(event);
    }

    return (
        <Box className={styles.form}>
            {label.multipleValues ?
                <Collapse in={label.required || showAdvanced || !!info?.infoValues?.length}>
                    <Autocomplete
                        key={label._id}
                        name={label.name}
                        multiple
                        disablePortal
                        onFocus={disableAutoComplete}
                        options={options || []}
                        renderInput={(params) => <TextField
                            key={label._id + '_text'}
                            error={!!errors && (activeElem === label._id)}
                            helperText={activeElem === label._id ? errors : ''}
                            name={label.name}
                            id={label._id}
                            {...params}
                            label={label.name} />
                        }
                        sx={{ margin: '10px 0' }}
                        value={value}
                        disabled={loading}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        filterOptions={filterOptions}
                        getOptionLabel={getOptionLabel}
                        onChange={handleAutocompleteChange}
                        helperText={activeElem === label._id ? errors : ''}
                        id={label._id}
                        filterSelectedOptions
                    />
                </Collapse>
                :
                <Collapse in={label.required || showAdvanced || !!info?.infoValue}>
                    {label.infoType === 'date' &&
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                            <LocalizationProvider key={label._id} dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={label.name}
                                    openTo="year"
                                    views={['year', 'month', 'day']}
                                    value={date}
                                    disabled={loading}
                                    className={!!errors ? 'has-error' : ''}
                                    renderInput={(params) => <TextField fullWidth sx={{ margin: '10px 0' }} {...params} />}
                                    onChange={handleInfoDateChange}
                                    disableMaskedInput
                                />
                            </LocalizationProvider>
                            {label.custom &&
                                <DeleteLabelModal
                                    label={label}
                                    uiStore={uiStore}
                                    btnStyle='iconOnly'
                                    updateData={updateData}
                                    category={category}
                                />
                            }
                        </Box>
                    }
                    {(label.infoType === "text" || label.infoType === "URL" ||
                        label.infoType === "email" || label.infoType === 'global-number') &&
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <TextField
                                key={label._id}
                                label={label.name}
                                value={value}
                                onFocus={disableAutoComplete}
                                className={styles.infoField}
                                sx={{ margin: '10px auto' }}
                                disabled={loading}
                                onChange={handleInfoChange}
                                onBlur={validateField}
                                error={!!errors && (activeElem === label._id)}
                                helperText={activeElem === label._id ? errors : ''}
                                name={label.name}
                                id={label._id}
                                placeholder={label.infoType === 'URL' ? 'https://website.com/username' : ''}
                                multiline={label.name === 'About' || label.name === 'Notes'}
                            />
                            {label.name === 'Nickname' &&
                                <DeleteSectionModal
                                    section={section}
                                    uiStore={uiStore}
                                    btnStyle='iconOnly'
                                    updateData={updateData}
                                    category='Name'
                                />
                            }
                            {label.custom &&
                                <DeleteLabelModal
                                    label={label}
                                    uiStore={uiStore}
                                    btnStyle='iconOnly'
                                    updateData={updateData}
                                    category={category}
                                />
                            }
                        </Box>
                    }

                    {label.infoType === "number" &&
                        <Box sx={{ display: "flex" }}>
                            <Autocomplete
                                key={label._id}
                                disablePortal
                                options={options || []}
                                renderInput={(params) => <TextField
                                    key={label._id + '_text'}
                                    onChange={handleChange}
                                    name={label.name}
                                    {...params}
                                    label='Country code' />
                                }
                                sx={{ margin: '10px 0', width: '30%', mr: 1 }}
                                value={countryCode}
                                disabled={loading}
                                onChange={handleCountryCodeChange}
                                renderOption={(props, option) => (
                                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                        <img
                                            loading="lazy"
                                            width="20"
                                            src={`https://flagcdn.com/w20/${option.icon.toLowerCase()}.png`}
                                            srcSet={`https://flagcdn.com/w40/${option.icon.toLowerCase()}.png 2x`}
                                            alt=""
                                        />
                                        {option.label}
                                    </Box>
                                )}
                                name={label.name}
                                id={label._id}
                                filterOptions={filterCountryCode}
                            />
                            <TextField
                                label={label.name}
                                value={value}
                                onFocus={disableAutoComplete}
                                className={styles.infoField}
                                sx={{ margin: '10px auto', width: '70%' }}
                                disabled={loading}
                                onChange={handleInfoChange}
                                onBlur={validateField}
                                error={!!errors && (activeElem === label._id)}
                                helperText={activeElem === label._id ? errors : ''}
                                name={label.name}
                                id={label._id}
                            />
                        </Box>
                    }

                    {(label.infoType === "blood-type") &&
                        <Autocomplete
                            key={label._id}
                            disablePortal
                            onFocus={disableAutoComplete}
                            options={options || []}
                            renderInput={(params) => <TextField
                                key={label._id + '_text'}
                                onBlur={validateField}
                                error={!!errors && (activeElem === label._id)}
                                helperText={activeElem === label._id ? errors : ''}
                                name={label.name}
                                onFocus={disableAutoComplete} {...params} label={label.name} />}
                            sx={{ margin: '10px 0' }}
                            value={value}
                            disabled={loading}
                            onChange={handleAutocompleteChange}
                            // onBlur={validateField}
                            // error={!!errors && (activeElem ===  label._id)}
                            helperText={activeElem === label._id ? errors : ''}
                            name={label.name}
                            id={label._id}
                        />
                    }

                    {(label.infoType === "address") &&
                        <>
                            <Autocomplete
                                key={label._id + 'country'}
                                required={'required'}
                                disablePortal
                                autoComplete={'nope'}
                                options={options || []}
                                renderInput={(params) => <TextField
                                    key={label._id + '_text'}
                                    onChange={handleChange}
                                    onBlur={validateField}
                                    error={!!errors && (activeElem === 'country')}
                                    helperText={activeElem === 'country' ? errors : ''}
                                    name={label.name}
                                    onFocus={disableAutoComplete} {...params} label={'Country'} />}
                                sx={{ margin: '10px 0', mb: 2 }}
                                value={country}
                                disabled={loading}
                                onChange={handleAddressChange}
                                onBlur={validateField}
                                error={!!errors && (activeElem === 'country')}
                                helperText={activeElem === 'country' ? errors : ''}
                                name={label.name}
                                id='country'
                                disableClearable
                                isOptionEqualToValue={(option, value) => option.value.toString() === value.value.toString()}
                            />
                            <Collapse in={country && states.filter(i => i.country_id === country?.id)?.length}>
                                <Autocomplete
                                    key={label._id + 'state'}
                                    disablePortal
                                    onFocus={disableAutoComplete}
                                    options={country ? states.filter(i => i.country_id === country?.id) : []}
                                    renderInput={(params) => <TextField
                                        key={label._id + '_text'}
                                        onChange={handleChange}
                                        onBlur={validateField}
                                        error={!!errors && (activeElem === 'state')}
                                        helperText={activeElem === 'state' ? errors : ''}
                                        name={'state'}

                                        onFocus={disableAutoComplete} {...params} label={'State'} />}
                                    sx={{ margin: '10px 0', mb: 2 }}
                                    value={state}
                                    disabled={loading}
                                    onChange={handleAddressChange}
                                    onBlur={validateField}
                                    error={!!errors && (activeElem === 'state')}
                                    helperText={activeElem === 'state' ? errors : ''}
                                    name={'state'}
                                    id='state'
                                    disableClearable
                                    isOptionEqualToValue={(option, value) => option?.value?.toString() === value?.value?.toString()}
                                />
                            </Collapse>
                            <Collapse in={state}>
                                <Autocomplete
                                    id='city'
                                    key={label._id + 'city'}
                                    disablePortal
                                    onFocus={disableAutoComplete}
                                    options={state ? cities.filter(i => i.state_id === state?.id) : country ? cities.filter(i => i.country_id === country) : []}
                                    renderInput={(params) => <TextField
                                        key={label._id + '_text'}
                                        onChange={handleChange}
                                        onBlur={validateField}
                                        error={!!errors && (activeElem === label._id + '_city_select')}
                                        helperText={activeElem === label._id + '_city_select' ? errors : ''}
                                        name={'city'}
                                        onFocus={disableAutoComplete} {...params} label={'City'} />}
                                    sx={{ margin: '10px 0' }}
                                    value={city}
                                    disabled={loading}
                                    onChange={handleAddressChange}
                                    onBlur={validateField}
                                    error={!!errors && (activeElem === label._id + '_city_select')}
                                    helperText={activeElem === label._id + '_city_select' ? errors : ''}
                                    name={'city'}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    getOptionLabel={getOptionLabel}
                                    disableClearable
                                    isOptionEqualToValue={(option, value) => option?.value?.toString() === value?.value?.toString()}
                                />
                            </Collapse>
                        </>
                    }

                    {label.infoType === 'location' &&
                        <LocationPicker
                            onChangeLocation={handleLocationChange}
                            LocationValue={info?.infoValue}
                        />
                    }

                    {(label.infoType === "day-time") &&
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize='14px'>{label.name}</Typography>
                                {availability &&
                                    <IconButton onClick={() => setShowAvailablityModal(true)}>
                                        <Edit2
                                            size="24"
                                            variant="Bulk"
                                        />
                                    </IconButton>
                                }
                            </Box>
                            {availability ?
                                <>
                                    {availability.status === 'open' &&
                                        <Box>
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500}>{day}</Typography>
                                                    Available All day | Open 24 hrs
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                    {availability.status === 'closed' &&
                                        <Box>
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500}>{day}</Typography>
                                                    Not available | Closed
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                    {availability.status === 'custom' &&
                                        <Box>
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500} fontSize={12}>{day}</Typography>
                                                    {dayjs(availability[day]['from']).format('hh:mm A')} - {dayjs(availability[day]['to']).format('hh:mm A')}
                                                </Box>
                                            )}
                                        </Box>
                                    }

                                </>
                                : <Button
                                    onClick={() => setShowAvailablityModal(true)}
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 2 }}
                                >
                                    Select Availability Days
                                </Button>
                            }

                            <AvailabilityModal
                                show={showAvailablityModal}
                                setShow={setShowAvailablityModal}
                                availability={availability}
                                setAvailability={setAvailability}
                                uiStore={uiStore}
                            />
                        </>
                    }

                </Collapse>
            }
        </Box>
    );
});

export default InfoForm;